import React, { useEffect, useState } from "react";
import shortid from "shortid";
import { Table } from "antd";

const columns = [
  {
    title: "CFOP",
    dataIndex: "Cfop",
    align: "center"
  },
  {
    title: "Grupo",
    dataIndex: "Grupo",
    align: "center"
  },
  {
    title: "Valor",
    dataIndex: "Valor",
    align: "right"
  },
  {
    title: "Valor de Desconto",
    dataIndex: "ValorDesconto",
    align: "right"
  },
  {
    title: "Valor de Frete",
    dataIndex: "ValorFrete",
    align: "right"
  },
  {
    title: "Valor de Acréscimo",
    dataIndex: "ValorAcrescido",
    align: "right"
  },
  {
    title: "Valor de Outras Despesas Acessórias",
    dataIndex: "ValorOutrasDespesas",
    align: "right",
  },
  {
    title: "Valor Total",
    dataIndex: "ValorTotal",
    align: "right"
  }
];

const CfopView = props => {
  const { list } = props;
  const [listConsider, setListConsider] = useState([]);
  const [listNotConsider, setListNotConsider] = useState([]);

  useEffect(() => {
    setListConsider(list.filter(item => item.ConsideraReceita));
    setListNotConsider(list.filter(item => !item.ConsideraReceita));
  }, [list]);

  return (
    <div className='cfop-view'>
      <Table
        className='table--success'
        columns={columns}
        dataSource={listConsider}
        rowKey={() => shortid.generate()}
        title={() => "Considera Receita"}
        size='small'
        pagination={false}
      />

      <Table
        className='table--danger'
        columns={columns}
        dataSource={listNotConsider}
        rowKey={() => shortid.generate()}
        title={() => "Desconsidera Receita"}
        size='small'
        pagination={false}
      />
    </div>
  );
};

export default CfopView;
